import type { Component } from "vue";

/**
 * Provide/inject contract for the small-screen nav control.
 *
 * `useSideNav` keeps its state in module-scope refs, so a page must reach the
 * HOST's module instance to open the drawer. A remote page cannot: MF
 * registration is one-directional (the host registers remotes, nothing
 * registers the host), so `loadRemote("<host>/layout")` has no name to resolve
 * in hosted mode, and neither repo declares a build-time `remotes` block.
 *
 * So the frame owns the state and hands down a ready-made component; page
 * headers only place it. Consumers never touch the composable or the remote
 * name.
 *
 * A STRING key, not a Symbol: symbol identity across an MF boundary depends on
 * both apps resolving the same module instance, which is exactly what we can't
 * rely on here.
 */
export const NAV_TOGGLE_KEY = "shipbob:navToggle";

/** What `inject(NAV_TOGGLE_KEY)` yields — render with `<component :is>`. */
export type NavToggleComponent = Component;
